var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrophyIcon = function SvgTrophyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.25 5.25v5.166c0 3.721 2.981 6.806 6.703 6.834a6.75 6.75 0 0 0 6.797-6.75V5.25A.75.75 0 0 0 18 4.5H6a.75.75 0 0 0-.75.75M9 21h6M12 17.25V21"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M18.581 12h.919a3 3 0 0 0 3-3V7.5a.75.75 0 0 0-.75-.75h-3M5.437 12H4.49a3 3 0 0 1-3-3V7.5a.75.75 0 0 1 .75-.75h3"
  })));
};
export default SvgTrophyIcon;